import { Typography } from "shared/ui/components/Typography";

import styles from "./TimelineCard.module.scss";

const TimelineCard = ({
  purchaseDate,
  finishDate,
  rentalIncomeDate,
}: {
  purchaseDate: string;
  finishDate: string;
  rentalIncomeDate: string;
}) => {
  return (
    <div className={styles.root}>
      <Typography variant="bodyL" weight="semiBold" className={styles.title}>
        Allgemein
      </Typography>
      <div className={styles.inner}>
        <div className={styles.row}>
          <Typography
            variant="bodyS"
            weight="semiBold"
            className={styles.title}
          >
            Betrachtungszeitraum
          </Typography>
          <Typography variant="bodyS" weight="regular" className={styles.title}>
            30 Jahre
          </Typography>
        </div>
        <div className={styles.row}>
          <Typography
            variant="bodyS"
            weight="semiBold"
            className={styles.title}
          >
            Kauftermin / Finanzierungsbeginn
          </Typography>
          <Typography variant="bodyS" weight="regular" className={styles.title}>
            {purchaseDate}
          </Typography>
        </div>
        <div className={styles.row}>
          <div>
            <Typography
              variant="bodyS"
              weight="semiBold"
              className={styles.title}
            >
              Bezugsfertigkeit
            </Typography>
            <Typography
              variant="bodyXS"
              weight="regular"
              className={styles.title}
            >
              (bei Bestandsimmobilien = Besitz-Nutzen-Lasten)
            </Typography>
          </div>
          <Typography variant="bodyS" weight="regular" className={styles.title}>
            {finishDate}
          </Typography>
        </div>

        <div className={styles.row}>
          <Typography
            variant="bodyS"
            weight="semiBold"
            className={styles.title}
          >
            Mietbeginn
          </Typography>
          <Typography variant="bodyS" weight="regular" className={styles.title}>
            {rentalIncomeDate}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default TimelineCard;
